export function getElementOffsetTop(
  doc: Document | null | undefined,
  selector: string,
): number | undefined {
  const elementOffsetTop =
    doc && doc.querySelector(selector) && (doc.querySelector(selector) as HTMLElement)?.offsetTop

  return elementOffsetTop as number | undefined
}
